import { DocumentAnswerV2Dto } from "src/backend";

export const isDocumentClean = (document: Pick<DocumentAnswerV2Dto, 'virusScanState'>): boolean => {
    return document?.virusScanState === 'CLEAN' || !document?.virusScanState
}